import { AvvirRoutingEvent } from "type_aliases";

export type ToInspectReportsEvent = AvvirRoutingEvent<typeof TO_INSPECT_REPORTS, { projectId: string, reportsBase?: "summary" | "reports" }>

const toInspectReports = (projectId: string, reportsBase: "summary" | "reports" = "summary"): ToInspectReportsEvent => ({
  type: TO_INSPECT_REPORTS,
  payload: {
    projectId,
    reportsBase
  }
});

export const TO_INSPECT_REPORTS = "to_inspect_reports";

export default toInspectReports;
